import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { RequestPermissionDialog } from '../components/auth/request-permission-dialog';
import { useNavigate } from 'react-router-dom';

const UserService = () => {
  const navigate = useNavigate();
  const { getAccessTokenSilently, isLoading, logout } = useAuth0();
  const [openRequestePermissionDialog, setOpenRequestePermissionDialog] = useState(false);

  const authoriseUser = async () => {
    const baseUrl = getApiBaseUrl();
    const token = await getAccessTokenSilently({
        authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          }
    });
    
    try {
      const response = await fetch(`${baseUrl}/Users`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 403) {
          setOpenRequestePermissionDialog(true);
        } else {
          logout();
        }
        console.error(`HTTP error! status: ${response.status}`);
        
      } else navigate(sessionStorage.getItem("redirectPathAfterAuth"));
    } catch (error) {
      logout();
      navigate(sessionStorage.getItem("redirectPathAfterAuth"));
    }
  };

  const onCloseRequestPermissionDialog = () => {
    logout();
  };
    
  const getApiBaseUrl = () => {
      const uiUrl = window.location.origin;
      switch(uiUrl) {
          case 'http://localhost:3000':
              return 'https://localhost:7214';
          case 'https://salmon-field-0d9fc360f.2.azurestaticapps.net':
              return 'https://dictionary-api.azurewebsites.net';
          default:
              return 'https://dictionary-api.azurewebsites.net';
      }
  };

  useEffect(() => {
    authoriseUser();
  });

  return (
    <>
      {isLoading && <>Loading...</>}
      <RequestPermissionDialog
        open={openRequestePermissionDialog}
        setOpen={setOpenRequestePermissionDialog}
        callback={onCloseRequestPermissionDialog}
        infoText="Thank you for your interest in joining our community. At the moment you don't have the required permissions to log in. Complete the form below to request access."
      />
    </>
    
  );
};

export default UserService;